module.exports = __webpack_public_path__ + "static/media/bg_plan_suggestion_from_45_to_49.37b7a78f.webp";